import React, { FC, useEffect } from 'react';
import { Tooltip } from 'antd';
import { color, SkeletonRow } from '@blink/components';
import { useDispatch, useSelector } from 'react-redux';

import { useUserSuppliesSectionStyle } from '../../UserSupplies/UserSuppliesSection/UserSuppliesSection.style';
import { AssetsToBorrowItemRow } from '../AssetsToBorrowItemRow';
import { useAssetsToBorrowSectionStyle } from './AssetsToBorrowSection.style';
import { ReactComponent as InfoIcon } from '../../../assets/info.svg';
import { Store } from '../../../store';
import { FixedRateMenuKey } from '../../FixedRateMenu/constants';
import { ROLE } from 'src/api/borrow';
import { getAgreementsAction } from 'src/store/agreements/actions';

type AssetsToBorrowSectionProps = {
    selectedRate: FixedRateMenuKey;
};

export const AssetsToBorrowSection: FC<AssetsToBorrowSectionProps> = ({ selectedRate }) => {
    const externalClasses = useUserSuppliesSectionStyle();
    const classes = useAssetsToBorrowSectionStyle();
    const { agreements, agreementsLoading, wallet } = useSelector((state: Store) => ({
        agreements: state.agreements.agreements,
        agreementsLoading: state.agreements.agreementsLoading,
        wallet: state.wallets.active.address,
    }));

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getAgreementsAction());
    }, [wallet]);

    const getContent = () => {
        if (agreementsLoading) {
            return (
                <>
                    <SkeletonRow />
                    <SkeletonRow />
                    <SkeletonRow />
                    <SkeletonRow />
                    <SkeletonRow />
                    <SkeletonRow />
                </>
            );
        }

        const indexes = [];
        for (const [i, item] of agreements.entries()) {
            if (item.role === ROLE.BORROWER) indexes.push(i);
        }

        return indexes.map((index) => (
            <AssetsToBorrowItemRow
                key={index}
                itemIndex={index}
                allItems={agreements}
                selectedRate={selectedRate}
            />
        ));
    };

    return (
        <div className={externalClasses.root}>
            <div className={externalClasses.title}>{'Assets to Borrow'}</div>
            <div className={externalClasses.tableWrapper}>
                <table className={externalClasses.table}>
                    <thead>
                        <tr className={externalClasses.tr}>
                            <th className={classes.asset}>Pools</th>
                            <th className={classes.asset}>Asset</th>
                            <th className={classes.totalSupplyWrapper}>Total Supply</th>
                            <th>
                                <div>
                                    <span>{`Borrow APY`}</span>{' '}
                                </div>
                            </th>
                            {selectedRate === FixedRateMenuKey.PROFIT_SHARING && (
                                <th>
                                    <div>
                                        <Tooltip
                                            className={classes.supply}
                                            rootClassName={classes.tooltipSupplyRoot}
                                            title='Sample'
                                            color={color.background.secondary}
                                        >
                                            <span>Profit Sharing</span>{' '}
                                            <InfoIcon className={classes.icon} />
                                        </Tooltip>
                                    </div>
                                </th>
                            )}
                            <th>Your Wallet</th>
                            <th className={classes.buttons} />
                        </tr>
                    </thead>
                    <tbody>{getContent()}</tbody>
                </table>
            </div>
        </div>
    );
};
